import { render } from "./DictionaryEditor.vue?vue&type=template&id=1b745576"
import script from "./DictionaryEditor.vue?vue&type=script&lang=js"
export * from "./DictionaryEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__